import { v4 as uuidv4 } from "uuid";
import { Segment } from "core/models/Segment";
import { MediaFile } from "core/models/MediaFile";

// A segment only has a duration, we calculate a specific
// timestamp value for a sequence of them when used in a player.
export type RelativeTimestamp = number;

export class Selection {
    id: string;

    segmentMap: Map<string, RelativeTimestamp>;

    segments: Segment[];

    trimStart: number;

    trimEnd: number;

    startSegmentID: string;

    endSegmentID: string;

    mediaFile?: MediaFile;

    constructor() {
        this.id = uuidv4();
        this.segmentMap = new Map<string, RelativeTimestamp>();
        this.segments = [];
        this.startSegmentID = "";
        this.endSegmentID = "";
        this.trimStart = 0.0;
        this.trimEnd = 0.0;
        this.mediaFile = undefined;
    }
}
